<template>
  <!-- How much less annual costs than 12 monthly instalments: the API's
       annual_discount, a percentage. Nothing renders without one.
       `tag` sits inline after a price, `banner` is a strip of its own, and
       `badge` is a pill the parent positions over a card's edge. -->
  <span v-if="percent && variant === 'tag'" class="reduction-tag"
    >{{ percent }}% reduction</span
  >
  <span
    v-else-if="percent"
    :class="variant === 'badge' ? 'reduction-badge' : 'reduction-banner'"
  >
    <span class="reduction-icon" aria-hidden="true">
      <svg viewBox="0 0 20 20">
        <path
          d="M10 2.5l1.9 4.6 4.6 1.9-4.6 1.9L10 15.5l-1.9-4.6L3.5 9l4.6-1.9L10 2.5z"
          fill="currentColor"
        />
      </svg>
    </span>
    <span>
      <strong>{{ percent }}% reduction</strong>
      <template v-if="variant === 'banner'"> when you pay annually</template>
    </span>
  </span>
</template>

<script>
export default {
  name: 'AnnualReduction',
  props: {
    discount: {
      type: Number,
      default: 0,
    },
    variant: {
      type: String,
      default: 'tag',
      validator: (v) => ['tag', 'banner', 'badge'].includes(v),
    },
  },
  computed: {
    percent() {
      const n = Math.round(Number(this.discount) || 0)
      return n > 0 ? n : 0
    },
  },
}
</script>

<style lang="scss" scoped>
// Contrast: $ps-green-hover on $ps-green-50 is 6.2:1, white on
// $ps-green-hover 6.8:1 — AA at any size.
.reduction-tag {
  display: inline-block;
  padding: 1px 7px;
  border-radius: 999px;
  background: $ps-green-50;
  color: $ps-green-hover;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.5;
  white-space: nowrap;
  vertical-align: 1px;
}

.reduction-banner {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  border: 1px solid rgba($ps-green, 0.25);
  border-radius: $ps-radius-sm;
  background: $ps-green-50;
  color: $ps-green-hover;
  font-size: 15px;
  line-height: 1.35;

  // Bulma gives every <strong> its dark $strong-color; inherit the
  // parent colour instead.
  strong {
    color: inherit;
    font-weight: 800;
  }

  .reduction-icon {
    flex: none;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 26px;
    height: 26px;
    border-radius: 50%;
    background: $ps-green-hover;
    color: $ps-white;

    svg {
      width: 15px;
      height: 15px;
    }
  }
}

.reduction-badge {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 4px 12px 4px 10px;
  border: 2px solid $ps-white;
  border-radius: 999px;
  background: $ps-green-hover;
  box-shadow: 0 2px 8px rgba($ps-green-hover, 0.25);
  color: $ps-white;
  font-size: 13px;
  line-height: 1.2;
  letter-spacing: 0.01em;
  white-space: nowrap;

  // Bulma gives every <strong> its dark $strong-color; inherit the
  // parent colour instead.
  strong {
    color: inherit;
    font-weight: 800;
  }

  .reduction-icon {
    display: inline-flex;

    svg {
      width: 13px;
      height: 13px;
    }
  }
}
</style>
